import { Component, ViewChild } from '@angular/core';
import { first, map } from 'rxjs/operators';
import { DealerService, SpinnerService, AuthenticationService } from '../services';
import { HttpClient } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs/Subscription';
import { Router, ActivatedRoute } from '@angular/router';
import { Dealer, NonCDKDealer, DealerSourceMapping } from '../models';
import { timer } from 'rxjs/observable/timer';
import {SelectItem} from 'primeng/api';
import * as moment from 'moment';
 import{Angular2Csv} from 'angular2-csv'
import { getDate } from 'ngx-bootstrap/chronos/utils/date-getters';
// import { Angular2Csv } from 'angular2-csv/Angular2-csv';

@Component({ templateUrl: 'edit-dealer.component.html' })
export class EditDealerComponent {
    pageTitle: any;
    editDealerForm: FormGroup;
    DealerGuid: any;
    DealerId: any;
    DealerDetails: any;
    Message: any = '';
    AlreadyExist: any = '';
    msgSuccess: boolean = false;
    currentUser: any;
    CountryCode: any;
    States: any[];
    Countries: any[];
    Oems: any[];
    timer: any;
    editFlag: boolean = true;
    msgAllReadyExist: boolean = false;
    nonOemCode: any;
    isNonOem: boolean = false;
    private subscription: Subscription = new Subscription();
    phoneNumbervalidationCheck: boolean = false;
    dlrSource: any[];
    srcOfDlr: any[];
    srcType: any[];
    stype: string;
    rowData: any;
    srcTypeList: any[];
    selectedSrcTypes: string[] = [];
    displayDialog: boolean;
    selectedDlrSource: any = -1;
    selectedSrcOfDlr: any = -1;
    selectedSrcType: any = -1;
    dlrCode: string;
    rowListData: any;
    dealerMappingId: any;
    NaturalKey: any;
    dealerSourceCols: Object;
    dealerName: any;
    LstDlrMapping: any;
    parentDealerId: any;
    DealerSources: any;
    isRed:boolean = true;
    isYellow:boolean = false;
    dealerSourceName: any;
    addsubscription:boolean;
    isShowSource:boolean=false;
    isOneTime:boolean=false;
    isDaily:boolean=false;
    isweekly:boolean=false;
    isMonthly:boolean=false;
    isYear:boolean=false;
    weekdays: SelectItem[]=[];
    selectedweekdays:any;
    dlrData: any;
    srcDlrCode: any;
    srcdlrSource: any;
    dlrSourceType: any;
    displayDltDialog: boolean;
    dealerSubscriptions: any[]=[];
    clientSubscriptionCols: Object;
    allSubscriptions: any;
    selectedData: any[]=[];
    ClientSubscriptionIds: any;
    displayDltSubscriptionDialog: boolean = false;
    selectedClientSubscriptionId: any;
    SubscriptionClientCount: any;
    DealerSourcecount: any[]=[];
    LogCreatedDates: any[]= [];
    saleFlag: any;
    serviceFlag: any;
    apptFlag: any;
    NcoaFlag: boolean;
    VinDecodingFlag: boolean;
    FleetIdentificationFlag: boolean;
    VinValidationFlag: boolean;
    DncFlag: boolean;
    ReturnMailerFlag: boolean;
    ActiveInactiveCustomerFlag: boolean;
    DistanceMilesFlag: boolean;
    NextServiceDueFlag: boolean;
    AdmCalculationsFlag: boolean;
    CcpaFlag: boolean;
    roles: any;
    role_check: any;
    Currdate: any = Date.now(); 
    errorMessage:any = "";
    effectiveDate:any;
    selectedDate:any=new Date().toISOString().slice(0, 10);
    deleteComments:any;
    dealerMapDelFlag:any = 0;
    dateRangeFilter: any = 7;
    trackingLogs: any;
    exportTrackingLogs: any;
    clients: any;
    clientId: any = 0;
    dealersubscriptionscols:any;
    
    constructor(
        private dealerService: DealerService,
        private fb: FormBuilder,
        private router: Router,
        private route: ActivatedRoute,
        private spinnerService: SpinnerService,
        private authenticationService: AuthenticationService,
        private http: HttpClient) {
            this.weekdays.push({label:'Sun', value:'Sun'});
            this.weekdays.push({label:'Mon', value:'Mon'});
            this.weekdays.push({label:'Tue', value:'Tue'});
            this.weekdays.push({label:'Wed', value:'Wed'});
            this.weekdays.push({label:'Thu', value:'Thu'});
            this.weekdays.push({label:'Fri', value:'Fri'});
            this.weekdays.push({label:'Sat', value:'Sat'});
         }

    ngOnInit() {
        this.spinnerService.start();
        this.authenticationService.currentUser.subscribe(x => this.currentUser = x);
        this.roles = localStorage.getItem('user-roles');
        this.role_check = this.roles.includes("InternalUser");

        this.editDealerForm = this.fb.group({
            NaturalKey: ['', [Validators.required]],
            DealerName: ['', [Validators.required]],
            PhoneNumber: ['', [Validators.required]],
            Address1: ['', [Validators.required]],
            Address2: [''],
            City: ['', [Validators.required]],
            State: ['', [Validators.required]],
            Zip: ['', [Validators.required]],
            TimeZone: ['', [Validators.required]],
            Country: ['', [Validators.required]],
            OemCode: ['', [Validators.required]],
            // OpcodeProcessedDate: [''],
            SalesforceID:[''],
            DPSId: [''],
            OneCommandId: [''],
            AutoloopId: ['']
        });
       
        this.subscription = this.route.params.subscribe(
            params => {
                this.DealerGuid = params['guid'];
            }
        );
        if (this.DealerGuid != '00000000-0000-0000-0000-000000000000') {
            this.pageTitle = "Edit Dealer";
            this.editFlag = true;
            this.getDealerDetails();

        }
        else {
            this.pageTitle = "Add Dealer";
            this.editFlag = false;
            this.getOems();
            this.getCountryNames();
        }
    }
    onChangeSelection(value)
    {
        if(value=="Master")
        { this.isShowSource = false; }
        else{this.isShowSource = true;}
    }
    OnChangeScheduleoptional(value)
    {
        this.isOneTime=false;
        this.isDaily=false;
        this.isMonthly=false;
        this.isYear=false;
        this.isweekly =false;

        if(value=="OneTime")
            this.isOneTime=true;
        if(value=="Daily")
            this.isDaily=true;
        if(value=="Weekly")
            this.isweekly=true;
        if(value=="Monthly")
            this.isMonthly=true;
        if(value=="Yearly")
            this.isYear=true;
    }
    dealerSource(value, data, rowMappinsLst) {
        this.spinnerService.start();
        this.dlrSource = [];
        this.srcOfDlr = [];
        this.srcType = [];
        this.stype = '';
        this.rowData = data;
        this.srcTypeList = [];
        this.selectedSrcTypes = [];
        if (value == 'Add') {
            this.dealerService.getDealerSources(0).pipe(first()).subscribe(dealerSources => {
                this.displayDialog = true;
                this.dlrSource = dealerSources.ListDlrSource;
                this.srcOfDlr = dealerSources.ListSrcOfDealer;
                this.srcType = dealerSources.ListSrcType;
                this.selectedDlrSource = -1;
                this.selectedSrcOfDlr = -1;
                this.dlrCode = '';
                this.stype = 'Add';
                for (let d of this.srcType) {
                    this.srcTypeList.push({ label: d.SourceCode, value: d.SourceCode });
                }
                this.spinnerService.stop();
            });
        }
        else {
            this.dealerService.getDealerSources(this.rowData.DealerMappingId).pipe(first()).subscribe(dealerSources => {
                this.displayDialog = true;
                this.rowListData = data;
        
                if (dealerSources.SrcCode) {
                    this.selectedSrcTypes = dealerSources.SrcCode.split(",");
                }
                this.dlrSource = dealerSources.ListDlrSource;
                this.srcOfDlr = dealerSources.ListSrcOfDealer;
                this.srcType = dealerSources.ListSrcType;
                this.selectedDlrSource = dealerSources.DealerSource;
                this.selectedSrcOfDlr = dealerSources.SourceOfDealer;
                this.dlrCode = dealerSources.SrcDealerCode;
                this.NcoaFlag = dealerSources.NcoaFlag;
                this.VinDecodingFlag = dealerSources.VinDecodingFlag;
                this.FleetIdentificationFlag = dealerSources.FleetIdentificationFlag;
                this.VinValidationFlag = dealerSources.VinValidationFlag;
                this.DncFlag = dealerSources.DncFlag;
                this.ReturnMailerFlag = dealerSources.ReturnMailerFlag;
                this.ActiveInactiveCustomerFlag = dealerSources.ActiveInactiveCustomerFlag;
                this.DistanceMilesFlag = dealerSources.DistanceMilesFlag;
                this.NextServiceDueFlag = dealerSources.NextServiceDueFlag;
                this.AdmCalculationsFlag = dealerSources.AdmCalculationsFlag;
                this.CcpaFlag = dealerSources.CcpaFlag;
    
                this.stype = 'Edit';
                for (let d of this.srcType) {
                    this.srcTypeList.push({ label: d.SourceCode, value: d.SourceCode });
                }
                this.dealerMappingId = this.rowData.DealerMappingId;
                this.spinnerService.stop();
            });
        }
    }
    getCountryNames() {
        this.dealerService.getCountryNames().pipe(first()).subscribe(data => {
            this.Countries = data;
            this.getStatesByCountryCode(false);
        });
    }
    onCountryChange(event: any) {        
        this.editDealerForm.controls['State'].setValue(null);
        if(event.target.value == 'null') {
           this.getStatesByCountryCode(true);
        }
        else {
            this.spinnerService.start();
            this.CountryCode = event.target.value;
            this.getStatesByCountryCode(true);
        }
    }
    getStatesByCountryCode(isChanged: boolean = false) {
        this.CountryCode =  this.editDealerForm.controls['Country'].value;
        if(this.CountryCode != ''){
            this.States = [];
            this.dealerService.getStatesByCountryCode(this.CountryCode).pipe(first()).subscribe(data => {
                this.States = data;                
                this.spinnerService.stop();
            });
        }
        else {
            this.States = [];
            this.spinnerService.stop();
        }
        
    }
    getDealerDetails() {
        this.dealerService.getDealerDetails(this.DealerGuid).pipe(first()).subscribe(data => {
            this.onDealerDetailsRetrieved(data);
            this.getOems();
            this.getCountryNames();
            this.getClients();
        });

    }
    getOems() {
        this.dealerService.getOemList().pipe(first()).subscribe(data => {
            this.Oems = data;

            if (this.DealerGuid != '00000000-0000-0000-0000-000000000000') {

                this.nonOemCode = this.editDealerForm.controls.OemCode.value;
                var result = this.Oems.filter(oem => oem.OemCode == this.nonOemCode)
                if (result.length > 0 || this.nonOemCode == null) {
                    this.isNonOem = false;
                }
                else {
                    this.isNonOem = true;
                    this.Oems = data;
                }
            }

        });
    }
    // integrating values to form controllers
    onDealerDetailsRetrieved(dealer: NonCDKDealer): void {
        if(this.pageTitle == 'Add Dealer'){
            this.DealerDetails = {0:''};
            this.DealerDetails[0] = dealer;
        }else{
            this.DealerDetails = dealer;
        }
        this.pageTitle = 'Edit Dealer'
        this.DealerId = this.DealerDetails[0].ParentDealerId;
        this.DealerGuid = this.DealerDetails[0].DealerGuid;
        this.NaturalKey = this.DealerDetails[0].NaturalKey;
        this.dealerName = this.DealerDetails[0].DealerName;
        this.parentDealerId = this.DealerDetails[0].ParentDealerId;
        this.getDealerTrackingLogs();
        this.editDealerForm.patchValue({
            NaturalKey: this.DealerDetails[0].NaturalKey,
            DealerName: this.DealerDetails[0].DealerName,
            SalesforceID:  this.DealerDetails[0].SalesforceID,
            PhoneNumber: this.DealerDetails[0].PhoneNumber,
            Address1: this.DealerDetails[0].Address1,
            Address2: this.DealerDetails[0].Address2,
            City: this.DealerDetails[0].City,
            State: this.DealerDetails[0].State,
            Zip: this.DealerDetails[0].Zip,
            Country: this.DealerDetails[0].Country,
            TimeZone: this.DealerDetails[0].TimeZone,
            OemCode: this.DealerDetails[0].OemCode=='null'?null:this.DealerDetails[0].OemCode,
            // OpcodeProcessedDate: this.DealerDetails[0].OpcodeProcessedDate,
            DPSId:  this.DealerDetails[0].DpsClientId,
            AutoloopId:  this.DealerDetails[0].AlClientId,
            OneCommandId:  this.DealerDetails[0].OcClientId,
        });
        this.RowExpand();
        this.clientSubscriptionsGetByPDealerId();
        this.getLogCreatedDate();
        this.GetCountOfDealerBySource();
        this.GetCountOfSubscriptionByClient();
        this.http.get('assets/data/dealersource-header.json').subscribe(results => {
            this.dealerSourceCols = results;
        });
    }
    deleteSource(rdata, rowData) {
        this.errorMessage = "";
        this.dlrData = rdata;
        this.rowData = rowData;
        this.srcDlrCode = rdata.SrcDealerCode;
        this.srcdlrSource = rdata.DealerSource;
        this.dlrSourceType = rdata.SourceType;
        this.displayDltDialog = true;
    }
    No() {
        this.displayDltDialog = false;
        this.errorMessage = "";
    }
    Yes(value:any, comments:any) {
        this.errorMessage = "";
        this.spinnerService.start();
        this.authenticationService.currentUser.subscribe(x => this.currentUser = x);
            if(typeof comments === 'undefined')
        {
            this.errorMessage = "Please enter Comments";
            this.spinnerService.stop();
        }
        else
        {
            if(value == new Date().toISOString().slice(0, 10))
            {
                this.dealerMapDelFlag = 0;
            }
            else
            {
                this.dealerMapDelFlag = 1;
            }
            this.dealerService.delDealerSources(this.dlrData.DealerMappingId,this.currentUser.userName,this.deleteComments,value,this.dealerMapDelFlag).pipe(first()).subscribe(dealerSources => {
                this.LstDlrMapping = this.LstDlrMapping.filter(item => item.DealerMappingId !== this.dlrData.DealerMappingId);
                this.displayDltDialog = false;                               
                this.spinnerService.stop();
                //window.location.reload(true)
            });
        }       
    }    
    RowExpand() {
        this.spinnerService.start();
        this.dealerService.getDealerMappings(this.parentDealerId).pipe(first()).subscribe(dealermappings => {
            this.LstDlrMapping = dealermappings;
            this.spinnerService.stop();
        })

    }
    getDealerMappings(data) {
        this.spinnerService.start();
        if (this.stype == 'Edit') {
            this.rowListData.ListDealerMapping = [];
            this.dealerService.getDealerMappings(this.parentDealerId).pipe(first()).subscribe(dealermappings => {
               this.rowListData.ListDealerMapping = dealermappings;
                this.LstDlrMapping = dealermappings;
                this.spinnerService.stop();
            })
        }
        else {
            this.dealerService.getDealerMappings(this.parentDealerId).pipe(first()).subscribe(dealermappings => {
                this.LstDlrMapping = dealermappings;
                this.spinnerService.stop();
            })
        }
    }
    SaveSources() {
        this.spinnerService.start();
        this.authenticationService.currentUser.subscribe(x => this.currentUser = x);
        this.DealerSources = new DealerSourceMapping();
        this.DealerSources.ParentDealerId = this.parentDealerId;
        this.DealerSources.DealerSource = this.selectedDlrSource;
        this.DealerSources.SourceOfDealer = this.selectedSrcOfDlr;
        if(this.selectedSrcTypes.includes('DECL') == true){
            this.DealerSources.RedFlag = this.isRed;
            this.DealerSources.YellowFlag = this.isYellow;
        }
        else {
            this.DealerSources.RedFlag = false;
            this.DealerSources.YellowFlag = false;
        }
        for (let s of this.selectedSrcTypes) {
            if (this.DealerSources.SrcCode) {
                this.DealerSources.SrcCode = s + ',' + this.DealerSources.SrcCode;
            }
            else {
                this.DealerSources.SrcCode = s;
            }
        }
        this.dealerSourceName = this.dlrSource.find(item => item.DealerSourceTypeId == this.selectedDlrSource);
        this.DealerSources.SelectedDealerSourceName = this.dealerSourceName.DealerSource;
        this.DealerSources.CreatedBy = this.currentUser.userName;
        this.DealerSources.stype = this.stype;
        this.DealerSources.dealerName = this.dealerName ;
        this.DealerSources.NaturalKey = this.NaturalKey;
        this.DealerSources.DealerCode = this.dlrCode;
        this.DealerSources.DealerCode = this.dlrCode;
        if(this.role_check){
            this.DealerSources.NcoaFlag = this.NcoaFlag;
            this.DealerSources.VinDecodingFlag = this.VinDecodingFlag;
            this.DealerSources.FleetIdentificationFlag = this.FleetIdentificationFlag;
            this.DealerSources.VinValidationFlag = this.VinValidationFlag;
            this.DealerSources.DncFlag = this.DncFlag;
            this.DealerSources.ReturnMailerFlag = this.ReturnMailerFlag;
            this.DealerSources.ActiveInactiveCustomerFlag = this.ActiveInactiveCustomerFlag;
            this.DealerSources.DistanceMilesFlag = this.DistanceMilesFlag;
            this.DealerSources.NextServiceDueFlag = this.NextServiceDueFlag;
            this.DealerSources.AdmCalculationsFlag = this.AdmCalculationsFlag;
            this.DealerSources.CcpaFlag = this.CcpaFlag;
        }
        
        if (this.dealerMappingId != null) {
            this.DealerSources.DealerMappingId = this.dealerMappingId;
        }
        else {
            this.DealerSources.DealerMappingId = 0;
        }
       this.checkCount(this.DealerSources);

    }
    saveDlrSource(DealerSources) {
        this.dealerService.saveDealerSources(DealerSources).subscribe(
            (result) => {
                this.getDealerMappings(this.parentDealerId);
                //window.location.reload(true)
            }
        )
        this.displayDialog = false;
    }
    checkCount(DealerSources) {
        this.dealerService.GetDealerSourceCount(DealerSources.ParentDealerId, DealerSources.DealerSource, DealerSources.DealerMappingId).subscribe(result => {
            if (result.DealerCount == 0) {
                this.msgAllReadyExist = false;
                this.saveDlrSource(DealerSources);
            }
            else {
                this.msgAllReadyExist = true;
                this.AlreadyExist = "This Dealer Already Exist.";
                this.spinnerService.stop();
            }
        });
    }
    DealerSave() {
        this.spinnerService.start();
        this.DealerDetails = new NonCDKDealer();
        this.phoneNumbervalidationCheck = false;
        let pnum = this.editDealerForm.controls.PhoneNumber.value;
        pnum = pnum.replace('_', '');
        if(pnum.length != 10){
            this.phoneNumbervalidationCheck = true;
            this.spinnerService.stop();
        }else{
            if (this.editDealerForm.valid) {
                if (this.editDealerForm.dirty) {
                    let mdlr = Object.assign({}, this.DealerDetails, this.editDealerForm.value);
                    mdlr.DpsClientId = this.editDealerForm.controls.DPSId.value;
                    mdlr.AlClientId = this.editDealerForm.controls.AutoloopId.value;
                    mdlr.OcClientId = this.editDealerForm.controls.OneCommandId.value;
                    mdlr.CreatedBy = this.currentUser.userName;
                    mdlr.DealerGuid = this.DealerGuid;
                    if(mdlr.OemCode =='null')
                    {mdlr.OemCode = null}
                    if (this.DealerGuid != '00000000-0000-0000-0000-000000000000') {
                        this.Save(mdlr);
                    }
                    else {
                        this.getDlrCount(mdlr);
                    }
                }
                else {
                    this.onSaveComplete();
                }
            }
        }
    }
    //save complete
    onSaveComplete(): void {
        this.msgSuccess = true;
        this.Message = "Saved Successfully.";
        this.spinnerService.stop();
        if(this.pageTitle == 'Add Dealer'){
            this.onDealerDetailsRetrieved(this.DealerDetails);
            this.timer = timer(100, 100);
            this.subscription.add(this.timer.subscribe(t =>
            this.router.navigate(['/dealer/endlr/'+this.DealerDetails[0].DealerGuid])));
        }
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
    Save(mdlr) {
        this.subscription.add(this.dealerService.DealerSave(mdlr).subscribe(
            (managedealer: any) => {
                this.DealerDetails = managedealer;
                this.onSaveComplete();
                error => { this.spinnerService.stop(); }
            }));
    }
    getDlrCount(mdlr) {
        this.dealerService.GetDlrCount(mdlr.NaturalKey,mdlr.OemCode).subscribe(result => {
            if (result.DealerCount == 0) {
                this.msgAllReadyExist = false;
                this.Save(mdlr)
            }
            else {
                this.msgAllReadyExist = true;
                this.AlreadyExist = "This Natural Key  already exist.";
                this.spinnerService.stop();
            }
        });
    }
    clientSubscriptionsGetByPDealerId(){
        this.dealerService.clientSubscriptionsGetByPDealerId(this.parentDealerId).subscribe(result => {
            this.http.get('assets/data/dealer_client_subscription_columns.json').subscribe(results => {
                this.clientSubscriptionCols = results;
            });
            this.dealerSubscriptions = result;
        });
    }
    onScourceOfDealerChange(value) {
        this.selectedSrcOfDlr = value;
    }
    onDealerScourceChange(value) {
        this.selectedDlrSource = value;
    }
    newsubscription(){
        this.spinnerService.start();
        this.selectedData = [];
        this.ClientSubscriptionIds = '';
        this.addsubscription = true;
        this.dealerService.DealerClientSubscriptionsGetAll(this.parentDealerId).subscribe(result => {
            this.http.get('assets/data/dealer-all-subscriptions-header.json').subscribe(results => {
                this.dealersubscriptionscols = results;
            });
            this.allSubscriptions = result;
            this.spinnerService.stop();
        });
    }
    RolecheckValue(event) {
        if (event.target.checked == true) {
            this.selectedData.push(event.target.value);
        }
        else {
            const index: number = this.selectedData.indexOf(event.target.value);
            if (index !== -1) {
                this.selectedData.splice(index, 1);
            }
        }
        this.ClientSubscriptionIds = this.selectedData.join(',');
    }
    ClientSubscriptionSave(){
        this.spinnerService.start();
        let mdlr = Object();
        if(this.ClientSubscriptionIds){
            mdlr.ParentDealerId = this.parentDealerId ;
            mdlr.ClientSubscriptionIds = this.ClientSubscriptionIds;
            mdlr.CreatedBy = this.currentUser.userName;
            this.dealerService.ClientSubscriptionSave(mdlr).subscribe(result => {
                this.clientSubscriptionsGetByPDealerId();
                this.addsubscription = false;
                this.spinnerService.stop();
            });
        }
    }
    deleteClientSubscription(){
        this.displayDltSubscriptionDialog = true;
        this.spinnerService.start();
        this.dealerService.dealerSubscriptionDelete(this.parentDealerId,this.selectedClientSubscriptionId,this.currentUser.userName).subscribe(result => {
            this.displayDltSubscriptionDialog = false;
            this.clientSubscriptionsGetByPDealerId();
            this.spinnerService.stop();
            error => { this.spinnerService.stop(); }
        });
    }
    closeDeletePopup(){
        this.displayDltSubscriptionDialog = false;
    }
    deleteClientSubscriptionpop(data){
        this.selectedClientSubscriptionId = data.ClientSubscriptionId;
        this.displayDltSubscriptionDialog = true;
    }
    GetCountOfDealerBySource(){
        this.dealerService.GetCountOfDealerBySource(this.parentDealerId).subscribe(result => {
            this.DealerSourcecount = result;
            error => { this.spinnerService.stop(); }
        });
    }
    GetCountOfSubscriptionByClient(){
        this.dealerService.GetCountOfSubscriptionByClient(this.parentDealerId).subscribe(result => {
            this.SubscriptionClientCount = result.ClientSubscriptionCount;
            result.FileTypeList.forEach(element => {
                if(element.FileTypeName == "Sales"){
                    this.saleFlag = element.IsSelected;
                }else if(element.FileTypeName == "Service"){
                    this.serviceFlag = element.IsSelected;
                }else{
                    this.apptFlag = element.IsSelected;
                }
            });
            if(result.ClientSubscriptionCount){
                this.SubscriptionClientCount.forEach(element => {
                    this.LogCreatedDates.forEach(e => {
                        if(e.CreatedDate == element.CreatedDt && element.Status.trim() == 'E'){
                            e.Status = 'Error';
                        }
                    });
                });
            }
            this.spinnerService.stop();
        });
    }
    getLogCreatedDate(){
        this.dealerService.getLogCreatedDate(this.parentDealerId).subscribe(result => {
            this.LogCreatedDates = result;
            error => { this.spinnerService.stop(); }
        });
    }
    downloadSuppressedRecord(created_dt,file_type_code,ClientName){
        this.spinnerService.start();
        this.dealerService.downloadSuppressedRecord(this.DealerId,file_type_code,ClientName,created_dt).subscribe(result => {
            if(result.SuppressionList != null){
                new Angular2Csv(result.SuppressionList,'SuppressionRecord', { headers: Object.keys(result.SuppressionList[0]) }) ;
            }
            this.spinnerService.stop();
            error => { this.spinnerService.stop(); }
        });
    }
    exportTrackingLog() {    
      
       this.spinnerService.start();
      
        import("xlsx").then(xlsx => {
            this.exportTrackingLogs.forEach(function(x){
                delete x.ParentDealerId;
                delete x.DateRangeFilter;
                delete x.ClientId;                
            });
            const worksheet = xlsx.utils.json_to_sheet(this.exportTrackingLogs);
            const workbook = { Sheets: { 'trackingLog': worksheet }, SheetNames: ['trackingLog'] };
            const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
            this.saveAsExcelFile(excelBuffer, "dealer_trackinglog");
        });
    }
    saveAsExcelFile(buffer: any, fileName: string): void {
        import("file-saver").then(FileSaver => {
            let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
            let EXCEL_EXTENSION = '.xlsx';
            const data: Blob = new Blob([buffer], {
                type: EXCEL_TYPE
            });
            FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
        });
        this.spinnerService.stop();
    }
    getDealerTrackingLogs(){
        this.trackingLogs = [];
        this.spinnerService.start();
        this.dealerService.dealerTrackingLogs(this.dateRangeFilter, this.parentDealerId,this.clientId).subscribe(result => {
            this.trackingLogs = result;
            this.exportTrackingLogs = result;
            this.spinnerService.stop();
            error => { this.spinnerService.stop(); }
        });
    }
    onclickdaterange(){
        this.getDealerTrackingLogs()
    }
    getClients() {
        this.dealerService.getClients().pipe(first()).subscribe(clients => {
            this.clients = clients;
        });
    }
}